import React, { useEffect, useRef, useState } from 'react';
import '../index.scss';
import { Button, notification, Space, Form, Input, Row, Col, Popconfirm } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import API_SERVICE from '../../../services/api-service';
import AccessControl from "../../../services/AccessControl";

export default function ConsumableTypes(props: {
    type?: 'soft' | 'consumable';
}) {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [count, setCount] = useState(0);
    const [consumablesTypes, setConsumablesTypeList] = useState([] as any);
    const [fetching, setFetching] = useState(true);
    const pendingSubmit = useRef(false);

    const getConsumablesTypeList = async () => {
        setFetching(true);
        try {
            const apiCall = props.type === 'soft'
                ? API_SERVICE.softwareConsumablesTypeList()
                : API_SERVICE.consumablesTypeList();
            const { data: { data } } = await apiCall;
            const mData = data.items.map((item: any, i: number) => ({ ...item, key: i }));
            setConsumablesTypeList(mData);
            setCount(data.items.length);
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => { getConsumablesTypeList(); }, []);

    useEffect(() => {
        if (pendingSubmit.current) {
            pendingSubmit.current = false;
            form.submit();
        }
    }, [consumablesTypes]);

    const addNewRow = () => {
        setConsumablesTypeList((prev: any) => prev.concat([{ id: null, name: '', key: count }]));
        setCount(c => c + 1);
    };

    const handleDelete = (key: number) => {
        setConsumablesTypeList((prev: any) => prev.filter((item: any) => item.key !== key));
    };

    const handleSave = () => {
        if (consumablesTypes.length === 0) {
            pendingSubmit.current = true;
            addNewRow();
        } else {
            form.submit();
        }
    };

    if (fetching) return <div>Getting Consumable Types...</div>

    return (
        <div>
            <Form
                size='large'
                form={form}
                onFinish={(formValues) => {
                    const reqObj: any = {
                        claimConsumables: consumablesTypes.map((item: any, i: number) => ({
                            id: item.id,
                            name: formValues['' + i] ?? ''
                        }))
                    };
                    setSaving(true);
                    const call = props.type === 'soft'
                        ? API_SERVICE.createBulkSoftwareConsumables(reqObj)
                        : API_SERVICE.createBulkClaimConsumables(reqObj);
                    call.then(() => {
                        notification.success({ message: 'Success' });
                        getConsumablesTypeList();
                    }).catch((e: any) => {
                        notification.error({ message: API_SERVICE.handleErrors(e) });
                    }).finally(() => {
                        setSaving(false);
                    });
                }}
                layout='vertical'
            >
                {consumablesTypes.map((item: any, index: number) => (
                    <Row key={`consumable-${item.key}`} align='middle' gutter={8} style={{ marginBottom: 0 }}>
                        <AccessControl id={236}>
                            <Col flex='32px'>
                                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.key)}>
                                    <div className='text-primary cursor-pointer text-center'>
                                        <MinusCircleOutlined />
                                    </div>
                                </Popconfirm>
                            </Col>
                        </AccessControl>
                        <Col>
                            <Form.Item
                                name={'' + index}
                                initialValue={item.name}
                                rules={[{ required: true, message: 'Name is required' }]}
                                style={{ marginBottom: 8 }}
                            >
                                <Input style={{ width: 200 }} placeholder='Enter name' />
                            </Form.Item>
                        </Col>
                    </Row>
                ))}
            </Form>
            <br />
            <AccessControl id={236}>
                <Row>
                    <Col offset={1} md={12}>
                        <Space>
                            <Button onClick={addNewRow} shape='round' icon={<PlusOutlined />} className="theme-button primary">
                                Add More
                            </Button>
                            <Button onClick={handleSave} shape='round' className="theme-button primary" loading={saving}>
                                Save
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </AccessControl>
        </div>
    );
}
